import { displayFontFamily } from "styles/theme";

const INK = "#0E3A2A";
const INK_MUTED = "#6B7770";
const HAIRLINE = "#E5DCC8";
const HAIRLINE_STRONG = "#D8CCB2";
const MINT = "#D6EFE0";
const MINT_INK = "#1F6B49";

const styles = {
  card: {
    borderRadius: "20px",
    border: `1px solid ${HAIRLINE}`,
    p: "22px",
  },
  iconBox: {
    background: MINT,
    color: MINT_INK,
  },
  badge: {
    background: MINT,
    color: MINT_INK,
  },
  bigStat: {
    display: "flex",
    alignItems: "baseline",
    gap: "6px",
    fontFamily: displayFontFamily,
    mt: "28px",
    mb: "6px",
  },
  bigStatNum: {
    fontFamily: displayFontFamily,
    fontSize: 56,
    fontWeight: 600,
    letterSpacing: "-2px",
    lineHeight: 1,
    color: INK,
  },
  bigStatUnit: {
    fontSize: 13,
    color: INK_MUTED,
    maxWidth: 200,
    lineHeight: 1.3,
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    mt: "12px",
  },
  filterLabel: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.8px",
    color: INK_MUTED,
    textTransform: "uppercase",
    width: 70,
    flexShrink: 0,
  },
  chipList: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
  niche: {
    backgroundColor: MINT,
    color: MINT_INK,
    px: "12px",
    py: "5px",
    borderRadius: "999px",
    fontSize: 12,
    fontWeight: 600,
  },
  nicheMore: {
    color: MINT_INK,
    pl: "4px",
    fontSize: 12,
    fontWeight: 600,
  },
  nicheAdd: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    backgroundColor: MINT,
    color: MINT_INK,
    px: "12px",
    py: "5px",
    borderRadius: "999px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": { backgroundColor: "#C7E9D5" },
  },
  actions: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
    mt: "auto",
    pt: "18px",
  },
  ctaPrimary: {
    backgroundColor: INK,
    color: "white",
    borderRadius: "999px",
    px: "18px",
    py: "11px",
    fontSize: 13.5,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": { backgroundColor: "#07271c" },
  },
  ctaGhost: {
    color: INK,
    border: `1px solid ${HAIRLINE_STRONG}`,
    borderRadius: "999px",
    px: "14px",
    py: "10px",
    fontSize: 12.5,
    fontWeight: 600,
    textTransform: "none",
    "&:hover": { backgroundColor: "#F4F0E7" },
  },
};

export default styles;
